import { AuthenticationMode } from './types';

type GetAuthenticationModeOptions = {
  isSSORequired: boolean;
  hasSAMLConfigured: boolean;
  hasLDAPConfigured: boolean;
  hasGoogleConfigured: boolean;
};

/**
 * Helper function to get the authentication mode for an organization.
 */
export function getAuthenticationMode({
  isSSORequired,
  hasSAMLConfigured,
  hasLDAPConfigured,
  hasGoogleConfigured,
}: GetAuthenticationModeOptions): AuthenticationMode {
  const hasSSO = hasSAMLConfigured || hasLDAPConfigured || hasGoogleConfigured;

  if (isSSORequired && hasSSO) {
    return AuthenticationMode.Sso;
  }

  if (isSSORequired) {
    return AuthenticationMode.OAuth;
  }

  if (!isSSORequired && hasSSO) {
    return AuthenticationMode.SsoEmail;
  }

  return AuthenticationMode.Email;
}
